import * as React from 'react';
import { Container } from '@mui/material';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, 
 } from '@mui/material';

import Service from '../../../util/Service';

const NodeStartEvent = React.forwardRef((props, ref) => {    
    const { item, processo } = props;
    const [modelos, setModelos] = React.useState();
    const [tipo, setTipo] = React.useState('evento-interno');
    const [frequencia, setFrequencia] = React.useState('unica');
    const [tempoEspera, setTempoEspera] = React.useState(5000);

    React.useEffect(()=>{
        if( processo && processo.lstTask){
            const i = processo.lstTask.find( t => t.idTask === item.id);
            
            if( i ){
                setTipo( i.tipo );
                // setCode( i.code );
                setFrequencia( i.frequencia );
                if( i.tipo === "backGround" ){
                    setTempoEspera( i.tempoEspera );
                    
                }
            }
        }
    }, [processo]);

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            handleComplete();
          }
    }))

    const handleComplete = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            tipo: tipo,
            taskType: item.type,
            frequencia: frequencia,
            tempoEspera: tempoEspera,
            // code: code
        }
        console.log( dado );
        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            console.log( resp );    
        }).catch(error => {
            console.error(error)
        })
    };
    return(
        <Container maxWidth="lg">
            <FormControl>
                     <FormLabel id="demo-radio-buttons-group-label">Indique a frequencia da execução</FormLabel>
                     <RadioGroup
                        value={frequencia}
                        onChange={(e)=> setFrequencia(e.target.value)}
                     >
                        <FormControlLabel value='unica' control={<Radio />} label="Rodar uma unica vez" />
                        <FormControlLabel value='multipla' control={<Radio />} label="Rodar continuamente" />
                        { frequencia === 'multipla' && 
                            <TextField 
                                id="tempoEspera" 
                                label="Tempo básico de espera entre execuções" 
                                variant="standard" 
                                value={tempoEspera}
                                onChange={(e)=> setTempoEspera(e.target.value)}
                                helperText="Em segundos"
                            />
                        }
                    </RadioGroup>
                    <FormLabel id="demo-radio-buttons-group-label">Escolha um modelo</FormLabel>
                    <RadioGroup
                        // aria-labelledby="demo-radio-buttons-group-label"                        
                        // name="radio-buttons-group"
                        value={tipo}
                        onChange={(e)=> setTipo(e.target.value)}
                    >
                        <FormControlLabel value="evento-interno" control={<Radio />} label="Evento Interno" />
                        <FormControlLabel value='backGround' control={<Radio />} label="BackGround" />
                        {modelos && modelos.map((m, i)=>
                            <FormControlLabel key={i} value={m} control={<Radio />} label={m.toUpperCase()} />
                        )}                        
                    </RadioGroup>
                </FormControl>
        </Container>
    )

});
export default NodeStartEvent;